import { Vue, Component, Prop } from 'vue-property-decorator';
import CodeMirror from '@/modules/code/components/code-mirror/code-mirror.vue';
import debounce from 'lodash.debounce';
import { ChangesObject } from 'components';
import CodeEditorActions from './subcomponents/code-editor-actions-logic';
import messageMutationsType from '@/modules/messaging/store/mutations-types';
import WithLoader from '@/components/with-loader/with-loader.vue';

@Component({
    components: {
        'code-mirror': CodeMirror,
        'code-editor-actions': CodeEditorActions,
        'with-loader': WithLoader
    },

    mounted() {
        this.isEditorVisible = this.$props.isVisible;
    },

    methods: {
        handleCodeChanges: debounce(function(this: any, evt: any) {
            const [cmInstance, changes, currentCode] = evt;
            const changesEvent: ChangesObject = {
                currentCode,
                changes
            };

            this.$emit('code:changed', changesEvent);
        }, 500)
    }
})
export default class CodeEditor extends Vue {
    isEditorVisible: boolean = true;
    cmInstance: CodeMirror.Editor | null = null;

    @Prop({
        default: ''
    })
    code!: string;

    @Prop({
        default: 500
    })
    delayChanges!: number;

    @Prop({
        default: false
    })
    isVisible!: boolean;

    @Prop({
        default() {
            return {};
        }
    })
    customOptions!: object;

    toggleEditorVisibility(): void {
        this.isEditorVisible = !this.isEditorVisible;

        this.$nextTick().then(() => {
            if (this.cmInstance) {
                this.cmInstance.refresh();
            }
        });
    }

    handleCodeMirrorReady(cmInstance: CodeMirror.Editor): void {
        this.cmInstance = cmInstance;
    }

    copyCode(): void {
        if ('clipboard' in navigator) {
            navigator.clipboard
                .writeText(this.code)
                .then(() => {
                    this.$store.commit(`messages/${messageMutationsType.ADD_MESSAGE}`, {
                        text: 'Skopiowano kod od schowka',
                        expires: 5000
                    });
                })
                .catch((err) => {
                    console.error(err);
                });
        }
    }
}
